<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <employee-claims-approvals-table-list :employee-uid="employee.employee_uid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    components: {
      EmployeeClaimsApprovalsTableList: () => import('@/components/employee/claims/approvals/TableList'),
    },
    metaInfo () {
      return {
        title: 'Claim Approval',        
      }
    },
    computed: {  
      ...mapState({ employee: 'currentEmployee' }),
    },
  }
</script>
